/** Body of send-to-production and send-email. Older backends answered with an empty body. */
export interface HttpSendToProductionResponse {
  message?: string;
  /** The AS400 order file went out (send-to-production only). */
  as400Sent?: boolean;
  /** The order is queued for tonight's AS400 flush instead (AS400_SEND_MODE=queue). */
  as400Queued?: boolean;
  /** The production email with the order PDF went out. */
  emailSent?: boolean;
  /** Outbound is disabled on this instance: nothing left it. */
  simulated?: boolean;
}

/**
 * The order reached AS400, or is queued for it, but its PDF/email did not go out (ISM4937,
 * 19 Oct 2026). The order is on its way to the atelier; "Send Email" finishes the job.
 */
export function isProductionEmailPending(response: unknown): boolean {
  if (!response || typeof response !== 'object') {
    return false;
  }
  const { as400Sent, as400Queued, emailSent } = response as HttpSendToProductionResponse;
  return (as400Sent === true || as400Queued === true) && emailSent === false;
}
